export default __webpack_public_path__ + "static/media/petshop.67406db7.png";